import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
import { ref, watch } from 'vue';
import store from '@/store';
import { useRouter } from 'vue-router';
export default {
  __name: 'Tabs',
  setup(__props) {
    const router = useRouter();
    const editableTabsValue = ref(store.state.editableTabsValue);
    const editableTabs = ref(store.state.editableTabs);
    const removeTab = targetName => {
      const tabs = editableTabs.value;
      let activeName = editableTabsValue.value;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      editableTabsValue.value = activeName;
      editableTabs.value = tabs.filter(tab => tab.name !== targetName);
      // 更新状态，保存当前标签页状态
      store.state.editableTabsValue = editableTabsValue.value;
      store.state.editableTabs = editableTabs.value;

      //  当面包屑关闭当前标签时，页面跳转到上一个标签页)
      router.push({
        path: activeName
      });
    };
    //点击面包屑跳转到指定页面
    const clickTab = tab => {
      // 获取当前标签的完整信息
      const currentTab = editableTabs.value.find(item => item.name === tab.paneName);
      if (!currentTab) return;

      // 如果是详情页面
      if (currentTab.name.includes('/detail/')) {
        // 从路径中提取 account_number
        const account_number = currentTab.name.split('/').pop();
        router.push({
          path: currentTab.name,
          params: {
            account_number
          }
        });
      } else {
        router.push(currentTab.name);
      }
    };
    const refreshTabs = () => {
      // 重新加载页面，更新当前标签页状态
      editableTabsValue.value = store.state.editableTabsValue;
      editableTabs.value = store.state.editableTabs;
    };
    watch(store.state, () => {
      refreshTabs();
    }, {
      deep: true,
      immediate: true
    });
    const addTab = route => {
      // 检查是否已存在相同 name 的标签页
      const existingTab = editableTabs.value.find(tab => {
        if (route.path.includes('/detail/')) {
          return tab.name === route.path;
        }
        return tab.name === route.name;
      });
      if (existingTab) {
        // 如果已存在，只更新当前活动标签页
        editableTabsValue.value = existingTab.name;
        return;
      }

      // 添加新标签页的逻辑
      if (!route.meta?.hidden) {
        const newTab = {
          title: route.meta?.title || 'new tab',
          name: route.path,
          route: route
        };

        // 如果是详情页，保存完整路径作为 name
        if (route.path.includes('/detail/')) {
          newTab.name = route.path;
        }
        editableTabs.value.push(newTab);
        editableTabsValue.value = newTab.name;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createBlock(_component_el_tabs, {
        modelValue: editableTabsValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => editableTabsValue.value = $event),
        type: "card",
        class: "demo-tabs",
        closable: "",
        onTabRemove: removeTab,
        onTabClick: clickTab
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableTabs.value, item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.name,
            label: item.title,
            name: item.name
          }, null, 8, ["label", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};